import { Tag } from '../pointers';
import { UnknownCreator } from '../types';

export const tagsRegistry = new Map<UnknownCreator, Tag[]>();
